import React, { Component } from 'react';
import tr from '../../libs/tr'
import Login from '../Login/Login';
// import Inseriscidati from '../Inseriscidati/Inseriscidati'
// import Confermail from '../Confermail/Confermail'
// import Haisbaglimail from '../Haisbaglimail/Haisbaglimail'
// import Termini from '../Termini/Termini';
// import Consensodati from '../Consensodati/Consensodati'
// import Benvenuto from '../Benvenuto/Benvenuto'
// import Inseriscicard from '../Inseriscicard/Inseriscicard'
// import Dovesciare from '../Dovesciare/Dovesciare'
// import Configadulto from '../Configadulto/Configadulto'
// import Configminore from '../Configminore/Configminore'
// import Caricaminore from '../Caricaminore/Caricaminore'
// import Trattaminore from '../Trattaminore/Trattaminore'
// import Ritirocard from '../Ritirocard/Ritirocard'
// import Riepicarrello from '../Riepicarrello/Riepicarrello'
// import Indirizione from '../Indirizione/Indirizione'
// import Insericredito from '../Insericredito/Insericredito'
// import Acquistuato from '../Acquistuato/Acquistuato'
// import Erroramento from '../Erroramento/Erroramento'
// import ScrollDialog  from '../Termini/ScrollDialog'
// import Userarea from '../Userarea/Userarea'

class Mainindex extends Component {

  constructor(props) {
    super(props);
    let params = null;
    console.log('[Mainindex]', params);
    this.state = {
      login: false,
      isertInfo: false,
    };

  }

  render() {

    return (
      <div>
        <Login/>
      </div>
    );
  }
}

export default Mainindex;


// WEBPACK FOOTER //
// ./src/screens/Mainindex/Mainindex.js